import { useCallback } from "react"
import { useIntl } from "react-intl"
import {
  defaultLocale,
  enUSMessages,
  type MessageId,
  type MessageValues,
} from "./messages"

export function useI18n() {
  const intl = useIntl()

  const t = useCallback(
    (id: MessageId, values?: MessageValues) =>
      intl.formatMessage(
        {
          defaultMessage: enUSMessages[id],
          id,
        },
        values,
      ),
    [intl],
  )

  const locale = (intl.locale || defaultLocale) as string

  return { locale, t }
}
